import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  template: null,
  versionDetails: {
    variables: ["email", "sender_id"],
  },
  emailRecords: [],
  batchName: null,
  batchResults: [],
  missingColumns: [],
  sender: "noreply@tomocredit.com",
};

const emailBatchingSlice = createSlice({
  name: "emailBatching",
  initialState,
  reducers: {
    addTemplate(state, action) {
      return {
        ...state,
        template: action.payload,
      };
    },
    addVersionDetails(state, action) {
      return {
        ...state,
        versionDetails: action.payload,
      };
    },
    addMissingColumns(state, action) {
      return {
        ...state,
        missingColumns: action.payload,
      };
    },
    // updateVersionDetails(state, action) {
    //   return {
    //     ...state,
    //     versionDetails: {
    //       ...state.versionDetails,
    //       [action.payload.type]: action.payload.value,
    //     },
    //   };
    // },
    addEmailRecords(state, action) {
      return {
        ...state,
        emailRecords: action.payload,
      };
    },
    addBatchName(state, action) {
      return {
        ...state,
        batchName: action.payload,
      };
    },
    addBatchResults(state, action) {
      return {
        ...state,
        batchResults: action.payload,
      };
    },
    setSender(state, action) {
      return {
        ...state,
        sender: action.payload,
      };
    },
    clearBatch(state, action) {
      return initialState;
    },
    // incrementByAmount(state, action) {
    //   state.value += action.payload;
    // },
  },
});

export const {
  addTemplate,
  addVersionDetails,
  addEmailRecords,
  addBatchName,
  addBatchResults,
  setSender,
  clearBatch,
  // updateVersionDetails,
  addMissingColumns,
} = emailBatchingSlice.actions;
export default emailBatchingSlice.reducer;
